import _forEach from 'lodash/forEach';
import _get from 'lodash/get';

// Constants
import { EMPTY_OBJECT, EMPTY_ARRAY } from '@tekion/tekion-base/app.constants';

// Readers
import NoteReader from '../Note.reader';
var getTaggedUserInfo = function getTaggedUserInfo() {
  var noteItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var ids = NoteReader.taggedUsers(noteItem) || EMPTY_ARRAY;
  var users = NoteReader.associatedUsers(noteItem) || EMPTY_OBJECT;
  var taggedUsers = {};
  _forEach(ids, function (id) {
    if (_get(users, id)) taggedUsers[id] = _get(users, id);
  });
  return taggedUsers;
};
export var getNoteItemData = function getNoteItemData() {
  var noteItem = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : EMPTY_OBJECT;
  var userImage = NoteReader.getUserImage(noteItem);
  var userName = NoteReader.getUserName(noteItem);
  var userRole = NoteReader.getUserRole(noteItem);
  var noteDate = NoteReader.getNoteCreatedTime(noteItem);
  var isNoteEdited = NoteReader.isNoteEdited(noteItem);
  var noteText = NoteReader.getNoteText(noteItem);
  var associatedUsers = getTaggedUserInfo(noteItem);
  return {
    userImage: userImage,
    userName: userName,
    userRole: userRole,
    noteDate: noteDate,
    isNoteEdited: isNoteEdited,
    noteText: noteText,
    associatedUsers: associatedUsers
  };
};
export var shouldShowDeleteOptionForNote = function shouldShowDeleteOptionForNote(_ref) {
  var showActionButtons = _ref.showActionButtons,
    canDeleteAnyNote = _ref.canDeleteAnyNote,
    canDeleteSelfAddedNote = _ref.canDeleteSelfAddedNote,
    isSameUser = _ref.isSameUser;
  var shouldShowDeleteForNote = showActionButtons || canDeleteAnyNote;
  if (!isSameUser) return shouldShowDeleteForNote;
  return canDeleteSelfAddedNote;
};